/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.WorkflowQueues";
        const DEFAULT_ICON_CLOSED = "wpt-font wpt-font-icon_Right";
        const DEFAULT_ICON_OPENED = "wpt-font wpt-font-icon_Down";
        class WorkflowQueuesWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("WorkflowQueuesWidgetTypeClass.createInstance()");
                    return new WorkflowQueuesWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("WorkflowQueuesWidgetTypeClass._storeHtml()");
                    WorkflowQueuesWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkflowQueuesWidgetTypeClass::constructor");
                if (WorkflowQueuesWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/WorkflowQueues/workflow-queues.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.WorkflowQueuesWidgetTypeClass = WorkflowQueuesWidgetTypeClass;
        class WorkflowQueuesWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._listHolder = null;
                this._loader = null;
                this._refreshSpan = null;
                this._noRecords = null;
                this._openedLCIcon = null;
                this._closedLCIcon = null;
                this._autoSelect = false;
                this._autoSelectOnHome = false;
                this._autoSelectMode = 'FIRSTNONEMPTY';
                this._autoSelectOnRefresh = false;
                this._hideEmptyQueues = false;
                this._refreshTriggers = null;
                this._onlyRefreshOnTriggers = false;
                this._refreshInProgress = false;
                this._queueData = null;
                this._lastItemCount = 0;
                this._filteredLifecycles = {};
                this._currentQueueId = 0;
                this._emptyQueueDeliberatelySelected = false;
                this._filterConstraints = [];
                this._queuesToPopulate = 0;
                this._queuesPopulated = 0;
                this._dataList = null;
                this._currentListData = null;
                this._currentSelectQueue = null;
                this._reactToSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this._lastReactedSlots = [];
                this.presentInstance = () => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = WorkflowQueuesWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._widgets.setTitle(this._config, this._container.querySelector('#workflowQueuesWidgetTitle'), 'STR_WPT_HEADINGWF');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._listHolder = this._container.querySelector('#workflowQueuesHolder');
                    this._refreshSpan = this._container.querySelector('#workflowQueuesReload');
                    this._noRecords = this._container.querySelector('#workflowQueuesNoRecords');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#workflowQueuesLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#workflowQueuesNoRecordsMessage'), 'STR_WPT_NO_QUEUES');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._refreshSpan.addEventListener('click', this._refreshClicked);
                    this._container.querySelector('#workflowQueuesNoRecordsReload').addEventListener('click', this._refreshClicked);
                    let config = this._config;
                    if (config.hasOwnProperty('OpenedLifecycleIcon') && (config.OpenedLifecycleIcon != null)) {
                        this._openedLCIcon = config.OpenedLifecycleIcon;
                    }
                    else {
                        this._openedLCIcon = DEFAULT_ICON_OPENED;
                    }
                    if (config.hasOwnProperty('ClosedLifecycleIcon') && (config.ClosedLifecycleIcon != null)) {
                        this._closedLCIcon = config.ClosedLifecycleIcon;
                    }
                    else {
                        this._closedLCIcon = DEFAULT_ICON_CLOSED;
                    }
                    if (config.hasOwnProperty('HideEmptyQueues') && (config.HideEmptyQueues))
                        this._hideEmptyQueues = config.HideEmptyQueues;
                    if (config.hasOwnProperty('AutoSelect') && (config.AutoSelect))
                        this._autoSelect = config.AutoSelect;
                    if (config.hasOwnProperty('AutoSelectOnHomeView') && (config.AutoSelectOnHomeView))
                        this._autoSelectOnHome = config.AutoSelectOnHomeView;
                    if (config.hasOwnProperty('AutoSelectOnRefresh') && (config.AutoSelectOnRefresh))
                        this._autoSelectOnRefresh = config.AutoSelectOnRefresh;
                    if (config.hasOwnProperty('AutoSelectMode') && (config.AutoSelectMode))
                        this._autoSelectMode = config.AutoSelectMode;
                    if (config.hasOwnProperty('DocumentFilter') && (config.DocumentFilter != null))
                        this._filterConstraints = config.DocumentFilter;
                    else
                        this._filterConstraints = [];
                    if (config.hasOwnProperty("ReactToSlots") && (config.ReactToSlots != null))
                        this._reactToSlots = config.ReactToSlots;
                    if (config.hasOwnProperty('OnlyRefreshOnTriggers') && (config.OnlyRefreshOnTriggers != null))
                        this._onlyRefreshOnTriggers = config.OnlyRefreshOnTriggers;
                    if (config.hasOwnProperty('RefreshTriggers') && config.RefreshTriggers && (config.RefreshTriggers.length > 0))
                        this._refreshTriggers = config.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    let listConfig = {
                        SelectItemCallback: this._queueClicked,
                        SublistIconOpened: this._openedLCIcon,
                        SublistIconClosed: this._closedLCIcon
                    };
                    this._dataList = new Widgets.ComponentDataList(this._core, this._listHolder, this, listConfig);
                    this._dataList.present();
                    this._getQueues();
                    this._type.instanceReady(this.Handle);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._refreshClicked = (event) => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._refreshClicked()");
                    this._getQueues();
                };
                this._getQueues = () => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._getQueues()");
                    this._core.Functions.showElement(this._loader);
                    this._core.Functions.hideElement(this._noRecords);
                    this._core.Functions.hideElement(this._listHolder);
                    this._core.Loader.genericServiceCall('/Workflow.svc/rest/GetMyWorkflowOverview', this._populateDocumentLists, this._callErrorHandler, this._callFailedHandler);
                };
                // Represents a potential nightmare.
                // Normally, we don't have populated document lists, but we have to if we are filtering - so grab them if absolutely necessary
                this._populateDocumentLists = (response) => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._populateDocumentLists()");
                    this._queueData = response.Workflows;
                    if (this._filterConstraints.length == 0)
                        this._displayQueues();
                    else {
                        let config = this._config;
                        let filterStrategy = 0;
                        if (config.hasOwnProperty("Queues") && (config.Queues.length > 0)) {
                            filterStrategy = 1;
                        }
                        else {
                            if (config.hasOwnProperty("Lifecycles") && (config.Lifecycles.length > 0)) {
                                filterStrategy = 2;
                            }
                        }
                        // Build the list of queues to display - this way we can minimise the number we have to pull down
                        let filteredQueues = [];
                        this._queueData.forEach(queue => {
                            switch (filterStrategy) {
                                case 0:
                                    filteredQueues.push(queue);
                                    break;
                                case 1:
                                    if (config.Queues.find(q => ((q.Name == queue.Name) && (q.Lifecycle == queue.LifeCycle.Name))))
                                        filteredQueues.push(queue);
                                    break;
                                case 2:
                                    if (config.Lifecycles.indexOf(queue.LifeCycle.Name) > -1)
                                        filteredQueues.push(queue);
                                    break;
                            }
                        });
                        // We may have no queues configured for display, in which case jump out
                        if (filteredQueues.length == 0) {
                            this._displayQueues();
                            return;
                        }
                        // Actually make all the service calls
                        this._queuesToPopulate = filteredQueues.length;
                        this._queuesPopulated = 0;
                        filteredQueues.forEach(queue => {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`populating '${queue.Name}'`);
                            }
                            this._core.Loader.genericServiceCall(`/Workflow.svc/rest/GetQueueDocuments/${queue.Id}`, this._receivedQueueDocuments.bind(this, queue.Id), this._callErrorHandler, this._callFailedHandler);
                        });
                    }
                };
                this._receivedQueueDocuments = (queueId, response) => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._receivedQueueDocuments()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`received documents for queue id ${queueId}`);
                    }
                    if (response.hasOwnProperty('Workflows')) {
                        // Make sure we get the queue we wanted back
                        let queue = response.Workflows.find(q => q.Id == queueId);
                        if (queue == null) {
                            this.addError(`Queue document search did not return record for indicated queue (ID: ${queueId})`);
                            this._queuesPopulated++;
                            if (this._queuesPopulated == this._queuesToPopulate) {
                                this._displayQueues();
                                return;
                            }
                        }
                        // Also need to find the maun queuedata queue
                        let mainQueue = this._queueData.find(q => q.Id == queueId);
                        if (mainQueue == null) {
                            this.addError(`Queue search did not return record for indicated queue (ID: ${queueId})`);
                            this._queuesPopulated++;
                            if (this._queuesPopulated == this._queuesToPopulate) {
                                this._displayQueues();
                                return;
                            }
                        }
                        // We can only get here if filtering is enabled
                        if (queue.Documents == null) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got empty list");
                            }
                            mainQueue.Documents = [];
                            mainQueue.ItemCount = 0;
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("filtering list");
                            }
                            mainQueue.Documents = this._core.OBHelper.filterDocumentList(queue.Documents, this._filterConstraints, null);
                            mainQueue.ItemCount = mainQueue.Documents.length;
                        }
                        this._queuesPopulated++;
                        if (this._queuesPopulated == this._queuesToPopulate) {
                            this._displayQueues();
                        }
                    }
                    else {
                        this.addError(`Queue document search did not return valid reponse for queue (ID: ${queueId})`);
                        this._queuesPopulated++;
                        if (this._queuesPopulated == this._queuesToPopulate) {
                            this._displayQueues();
                        }
                    }
                };
                this._displayQueues = () => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._displayQueues()");
                    this._refreshInProgress = false;
                    this._core.Functions.hideElement(this._loader);
                    let config = this._config;
                    this._lastItemCount = 0;
                    this._dataList.clearList();
                    // Sort out filtering strategy: 0 =  none, 1 = by queue, 2 = by lifecycle
                    let filterStrategy = 0;
                    if (config.hasOwnProperty("Queues") && (config.Queues.length > 0)) {
                        filterStrategy = 1;
                    }
                    else {
                        if (config.hasOwnProperty("Lifecycles") && (config.Lifecycles.length > 0)) {
                            filterStrategy = 2;
                        }
                    }
                    // Need to count - may end up with no queues displayed due to filtering
                    let displayedQueues = 0;
                    // May need something for autoselect mode
                    let autoSelectId = null;
                    if ((this._queueData != null) && (this._queueData.length > 0)) {
                        // Display format is dependent on how many lifecycles we are showing queues for, so
                        // run through the queue data and make a new list
                        this._filteredLifecycles = {};
                        let listData = {
                            Items: []
                        };
                        // Build the list of queues to display
                        this._queueData.forEach(queue => {
                            let displayQueue = false;
                            switch (filterStrategy) {
                                case 0:
                                    displayQueue = true;
                                    break;
                                case 1:
                                    if (config.Queues.find(q => ((q.Name == queue.Name) && (q.Lifecycle == queue.LifeCycle.Name))))
                                        displayQueue = true;
                                    break;
                                case 2:
                                    if (config.Lifecycles.indexOf(queue.LifeCycle.Name) > -1)
                                        displayQueue = true;
                                    break;
                            }
                            if (displayQueue) {
                                if (!this._filteredLifecycles.hasOwnProperty(queue.LifeCycle.Name))
                                    this._filteredLifecycles[queue.LifeCycle.Name] = [];
                                this._filteredLifecycles[queue.LifeCycle.Name].push(queue);
                            }
                        });
                        // Loop and display
                        for (let lcName in this._filteredLifecycles) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`processing LC '${lcName}'`);
                            }
                            // We can do the next thing because we won't create an entry without at least one record -
                            // But need to be mindful that we might be hiding empty queues
                            let populatedQueue = false;
                            let lifecycle = this._filteredLifecycles[lcName][0].LifeCycle;
                            let lcCount = 0;
                            let lcItem = {
                                Id: lifecycle.Id.toString(10),
                                DisplayName: lcName,
                                Items: []
                            };
                            this._filteredLifecycles[lcName].forEach(queue => {
                                // Need to do some possible filtering here
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`processing queue '${queue.Name}'`);
                                }
                                // On with the UI
                                let queueItem = {
                                    Id: queue.Id.toString(10),
                                    DisplayName: queue.Name,
                                    SuffixBadge: queue.ItemCount.toString(10)
                                };
                                lcCount += queue.ItemCount;
                                this._lastItemCount += queue.ItemCount;
                                if (queue.ItemCount > 0) {
                                    populatedQueue = true;
                                    displayedQueues++;
                                }
                                else if (this._hideEmptyQueues)
                                    queueItem.IsHidden = true;
                                else
                                    displayedQueues++;
                                // Autoselect logic
                                if (this._autoSelect && (this._autoSelectOnHome || (this._currentLayout != 'Home'))) {
                                    if (!autoSelectId) {
                                        if (this._autoSelectMode == 'FIRST')
                                            autoSelectId = queueItem.Id;
                                        else if ((this._autoSelectMode == 'FIRSTNONEMPTY') && (queue.ItemCount > 0))
                                            autoSelectId = queueItem.Id;
                                        else if (this._autoSelectMode == queue.Name)
                                            autoSelectId = queueItem.Id;
                                    }
                                }
                                lcItem.Items.push(queueItem);
                            });
                            lcItem.SuffixBadge = lcCount.toString(10);
                            if (!populatedQueue && this._hideEmptyQueues)
                                lcItem.IsHidden = true;
                            listData.Items.push(lcItem);
                        }
                        this._currentListData = listData;
                        this._dataList.displayData(listData);
                    } // if we got any queue data
                    if (displayedQueues == 0) {
                        this._core.Functions.showElement(this._noRecords);
                    }
                    else {
                        this._core.Functions.showElement(this._listHolder);
                    }
                    // Immediate UI effects
                    if (this._lastItemCount == 0)
                        this._noItemsNotify();
                    if (autoSelectId) {
                        this._queueClicked(autoSelectId);
                    }
                    else if (this._currentSelectQueue) {
                        this._dataList.selectItemAndClearIfFound(this._currentSelectQueue);
                        this._currentSelectQueue = null;
                    }
                };
                this._queueClicked = (id) => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._queueClicked()");
                    let config = this._config;
                    this._currentQueueId = Number(id);
                    let selectedQueue = this._queueData.find(queue => queue.Id == this._currentQueueId);
                    this._emptyQueueDeliberatelySelected = (selectedQueue.ItemCount == 0);
                    // Update the UI
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(id);
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_QUEUE_SELECTED);
                    navEvent.ActivationID = this._currentQueueId;
                    navEvent.PrimaryContext = selectedQueue;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "Workflow";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this.refreshCounts = () => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass.refreshCounts()");
                    // Just don't get involved ina refresh if there is one already hapenning
                    if (this._refreshInProgress)
                        return;
                    this._refreshInProgress = true;
                    this._clearErrors();
                    if (this._filterConstraints.length == 0) {
                        this._core.Loader.genericServiceCall('/Workflow.svc/rest/GetMyWorkflowOverview', this._updateQueueCounts, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        // Easiest to completely rebuild if we have filters set up - the overview doesn't pass documents, only counts
                        this._core.Loader.genericServiceCall('/Workflow.svc/rest/GetMyWorkflowOverview', this._populateDocumentLists, this._callErrorHandler, this._callFailedHandler);
                    }
                };
                this._updateQueueCounts = (response) => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._updateQueueCounts()");
                    this._refreshInProgress = false;
                    this._queueData = response.Workflows;
                    let autoSelectId = null;
                    let selectedQueueCount = 0;
                    // Loop from the context of the UI. Filtering happened on first population so we can use the UI
                    // as keys into the new counts label.
                    let lcVisible = false; // True if we are showing at least one lifecycle
                    if (this._currentListData) {
                        this._currentListData.Items.forEach(lcItem => {
                            let currentLCId = Number(lcItem.Id);
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`checking LC '${currentLCId}'`);
                            }
                            let populatedChild = false;
                            lcItem.Items.forEach(queueItem => {
                                let currentQueueId = Number(queueItem.Id);
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`checking queue '${currentQueueId}'`);
                                }
                                // Find our queue in the list
                                let queue = response.Workflows.find(q => ((q.Id == currentQueueId) && (q.LifeCycle.Id == currentLCId)));
                                if (!queue) {
                                    // TODO: translation
                                    this.addError(`Server did not send data for queue ${currentQueueId} in lifecycle ${currentLCId}`);
                                    queueItem.SuffixBadge = "0";
                                    return;
                                }
                                // We aren't filtering here - we just grabbed he overview so there are no documents
                                // Find and update the badge
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`updating queue with count '${queue.ItemCount}'`);
                                }
                                queueItem.SuffixBadge = queue.ItemCount.toString(10);
                                // Hide this row if necessary
                                if (this._hideEmptyQueues && (queue.ItemCount == 0)) {
                                    queueItem.IsHidden = true;
                                }
                                else {
                                    queueItem.IsHidden = false;
                                    populatedChild = true;
                                }
                                // Autoselect logic
                                if (queue.Id == this._currentQueueId)
                                    selectedQueueCount = queue.ItemCount;
                                // ONLY autoselect if the current queue ID is empty
                                if (this._autoSelectOnRefresh && (this._autoSelectOnHome || (this._currentLayout != 'Home'))) {
                                    if (!autoSelectId) {
                                        if (this._autoSelectMode == 'FIRST')
                                            autoSelectId = queueItem.Id;
                                        else if ((this._autoSelectMode == 'FIRSTNONEMPTY') && (queue.ItemCount > 0))
                                            autoSelectId = queueItem.Id;
                                        else if (this._autoSelectMode == queue.Name)
                                            autoSelectId = queueItem.Id;
                                    }
                                }
                            });
                            // If we have hidden all the childred, hide LC
                            if (this._hideEmptyQueues && !populatedChild) {
                                lcItem.IsHidden = true;
                            }
                            else {
                                lcItem.IsHidden = false;
                                lcVisible = true;
                            }
                        });
                    }
                    // We may have absolutely no elements showing, in which case move to "no content" display state
                    if (lcVisible) {
                        this._dataList.displayData(this._currentListData);
                        this._core.Functions.showElement(this._listHolder);
                        this._core.Functions.hideElement(this._noRecords);
                    }
                    else {
                        this._core.Functions.hideElement(this._listHolder);
                        this._core.Functions.showElement(this._noRecords);
                        this._noItemsNotify();
                    }
                    // If we've established an auto select entry, hit it now IF we have exhausted the previously selected queue
                    if (autoSelectId && (selectedQueueCount == 0) && !this._emptyQueueDeliberatelySelected) {
                        this._queueClicked(autoSelectId);
                    }
                };
                this._noItemsNotify = () => {
                    this._log.info("WorkflowQueuesWidgetInstanceClass._noItemsNotify()");
                    if (this._currentLayout != WPTNamespace.Navigation.HOME_VIEW_NAME) {
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_NO_ITEMS);
                        navEvent.ActivationID = 0;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkflowQueuesWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            get TotalItems() {
                return this._lastItemCount;
            }
            activate(context) {
                this._log.info("WorkflowQueuesWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                if (!this._onlyRefreshOnTriggers) {
                    switch (context.ActivationType) {
                        case WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_ACTION_FIRED:
                            // NOTE: This may cause two refreshes in short order. It's the default but the WF layout handles this 
                            // more efficiently in its own activatin code by only refreshing on DOCUMENT_DESELECTED
                            this.refreshCounts();
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                            let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                            if (slots.length > 0) {
                                // only remember slots we react to
                                this._lastReactedSlots = slots;
                                let queueId = null;
                                if (context.AdditionalContext && context.AdditionalContext.hasOwnProperty('SourceQueueRecord')) {
                                    queueId = context.AdditionalContext.SourceQueueRecord.Id;
                                }
                                else if (context.AdditionalContext && context.AdditionalContext.hasOwnProperty('SourceQueueID')) {
                                    queueId = context.AdditionalContext.SourceQueueID;
                                }
                                if (queueId) {
                                    if (this._currentListData) {
                                        this._dataList.selectItemAndClearIfFound(queueId);
                                    }
                                    else {
                                        this._currentSelectQueue = queueId;
                                    }
                                }
                            }
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                            let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                            if (intersection.length > 0) {
                                this._lastReactedSlots = [];
                                this.refreshCounts();
                            }
                            break;
                        default:
                            break;
                    }
                }
                if (this._refreshTriggers.length > 0) {
                    // Loop with iterator so we can escape when necessary
                    for (let i = 0; i < this._refreshTriggers.length; i++) {
                        let trigger = this._refreshTriggers[i];
                        if (this._core.Functions.triggerEventMatches(trigger, context)) {
                            this.refreshCounts();
                            // Only trigger once
                            return;
                        }
                        else {
                            continue;
                        }
                    }
                }
            }
        }
        WorkflowQueuesWidgetInstanceClass.HtmlData = null;
        Widgets.WorkflowQueuesWidgetInstanceClass = WorkflowQueuesWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
